class EmmaliciousCocadaPremium extends HTMLElement {
  connectedCallback() {
    this.dispatchEvent(new CustomEvent('emma-premium-ready', {bubbles: true}));
  }
  get root() {
    return this.closest('[data-tray-customizer], [data-emma-syrup]');
  }
  get selection() {
    const counts = {Pistachio: 0, Nuez: 0};
    const add = (flavor, quantity) => {
      if (Object.hasOwn(counts, flavor)) counts[flavor] += quantity;
    };
    const root = this.root;
    if (root?.matches('[data-tray-customizer]')) {
      root.querySelectorAll('[data-row="cocada"]').forEach(row => {
        add(row.dataset.flavor, Math.max(0, Math.floor(Number(row.querySelector('input').value) || 0)));
      });
    } else if (root) {
      root.querySelectorAll('[data-emma-standard-flavor] input:checked:not(:disabled), .bundle-cups__choices--cocada input:checked:not(:disabled)').forEach(input => add(input.value, 4));
      root.querySelectorAll('emmalicious-cocada-mix').forEach(control => {
        if (control.querySelector('[data-emma-mix-toggle]:checked')) {
          control.querySelectorAll('[data-emma-piece]:not(:disabled)').forEach(input => add(input.value, 1));
        }
      });
    }
    return {
      count: Object.values(counts).reduce((sum, value) => sum + value, 0),
      detail: Object.entries(counts).filter(([, count]) => count > 0).map(([flavor, count]) => count + ' × ' + flavor).join('; '),
    };
  }
  get isAvailable() {
    return this.dataset.available === 'true' && Number(this.dataset.variant) > 0 && Number(this.dataset.price) > 0;
  }
  validate() {
    const valid = this.selection.count === 0 || this.isAvailable;
    this.querySelector('[data-premium-error]').hidden = valid;
    if (!valid) this.scrollIntoView({block: 'center'});
    return valid;
  }
  cartItem(quantity, group) {
    const selection = this.selection;
    if (!selection.count) return null;
    if (!this.isAvailable) throw new Error('Premium cocada pricing unavailable');
    return {
      id: Number(this.dataset.variant),
      quantity: quantity * selection.count,
      properties: {
        _emma_syrup_group: group,
        _emma_syrup_role: 'addon',
        _emma_addon_type: 'cocada-premium',
        _emma_addon_units: String(selection.count),
        'Premium cocadas per item': selection.detail,
      },
    };
  }
}
if (!customElements.get('emmalicious-cocada-premium')) customElements.define('emmalicious-cocada-premium', EmmaliciousCocadaPremium);
